/**
 * 쿠키 키 상수
 */
export const COOKIE_KEYS = {
  /** 테마 모드 (light | dark) */
  THEME_MODE: 'enter-launcher-theme-mode',
} as const;
